import { gql } from 'apollo-boost';

// input DeleteUserInput {
// 	userId: String!
//  email: String!
// }

export const DELETE_USER = gql`
    mutation($data: DeleteUserInput!) {
        deleteUser(data: $data) {
            __typename
            ... on User {
                id
                email
                deletedAt
            }
            ... on InternalServerError {
                message
            }
            ... on DbStartTransactionError {
                message
            }
        }
    }
`;
